const TangoRomanticaFollow = {
    name: "Tango Romantica",
    bpm: 112,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default TangoRomanticaFollow;